<template>
  <v-container fluid class="ma-0 pa-0">
    <div :class="[$vuetify.breakpoint.smAndUp ? 'my-5 ml-5 py-5 pl-5' : 'my-3 ml-3 py-3 pl-3']">
    <v-layout row wrap grid-list-md>
      <v-flex class="mb-5 mt-2 mr-5">
        <h1 :class="[$vuetify.breakpoint.smAndUp ? '' : 'display-1']" class="covid-page-title">COVID-19 Resources for Students</h1>
        <p :class="[$vuetify.breakpoint.smAndUp ? '' : 'subheading']" class="covid-page-text">Your world has changed a lot in the past several months.
          Wading through resources to find the type of support you need as a student can be
          challenging and overwhelming. We're here to help make that easier. Scroll through
          our curated library of videos, articles, and interactive tools just for students
          to help manage your academic, financial, wellness, and career journeys. From studying
          tips to virtual interview guidelines, we’re here to help you move forward.</p>
      </v-flex>
      <v-flex class="xl-2">
          <v-layout col wrap align-center>
            <p class="covid-page-filter-text mb-0">FILTER BY:</p>
            <filter-button v-on:click-filter-btn="toggleFilter('Popular')" title="Popular" />
            <filter-button v-on:click-filter-btn="toggleFilter('TD Resource')" title="TD Resources" />
            <filter-button v-on:click-filter-btn="toggleFilter('Academics')" title="Academics" />
            <filter-button v-on:click-filter-btn="toggleFilter('Finance')" title="Finance" />
            <filter-button v-on:click-filter-btn="toggleFilter('Wellness')" title="Wellness" />
            <filter-button v-on:click-filter-btn="toggleFilter('Career')" title="Career" />
          </v-layout>
      </v-flex>
    </v-layout>

    <v-layout v-if="filtering">
      <v-flex class="mt-5">
        <v-flex>
          <h1 class="covid-page-section-title text-left">Based on your filters</h1>

        </v-flex>
        <v-container  fluid class="my-0 ml-0 mr-5 pa-0">
        <v-layout row wrap grid-list-xl class="mr-5">
        <v-flex
           class="card-container"
              v-for="(resource, index) in filteredResources"
              v-bind:key="`${resource}${index}`"
              xs12
          sm6
          md4
          lg4
          xl3>
          <resourceCard
            class="mr-3 mb-3"
            :minWidth="0"
            :resource="resource"
            />
        </v-flex>
        </v-layout>
       </v-container>
        </v-flex>
    </v-layout>

    <v-layout v-else column>
        <v-flex class ="mt-5"
        v-for="(resources, name) in resourceBuckets"
        :key="`${name}`">
        <div v-if="resources.length > 0">

          <v-flex>
          <h1 class='text-left covid-page-section-title'>{{name}}</h1>
          </v-flex>

          <v-layout row class='horizontal-scroll'>
              <resourceCard
                class="mr-3"
                v-for="(resource, index) in resources"
                :key="`${index}`"
                :minWidth="$vuetify.breakpoint.smAndUp ? 370 : 270"
                :resource="resource"/>
          </v-layout>
          </div>
      </v-flex>
    </v-layout>
    </div>
  </v-container>
</template>

<style lang="scss">

  .covid-page-section-title {
    font-style: normal;
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    color: #333333;
  }

.covid-page-title {
  text-align: left;
  font-style: normal;
  font-weight: 800;
  font-size: 50px;
  line-height: 120%;
  color: #000000;
}

.covid-page-text {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 160%;
  color: #000000;
}
.horizontal-scroll {
  overflow-x: auto;
  white-space: nowrap;
}

.card-container {
  display:flex;
  flex-flow:column;

}
.covid-page-filter-text {
  text-align: left;
  margin-right: 10px;
  width: fit-content;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
</style>

<script>
import { db } from '@/db.js'
import filterButton from '@/components/filterButton.vue'
import projectCardVue from '@/components/projectCard.vue'
import resourceCard from '@/components/resourceCard.vue'

export default {
  name: 'covidResources',
  components: {
    filterButton,
    resourceCard
    // HorizontalScroll
  },
  data () {
    return {
      resources: [],
      activeFilters: [],
      toggleTags: [
        {
          id: 'popular',
          title: 'Popular'
        },
        {
          id: 'TDResource',
          title: 'TD Resources'
        }
      ],
      categories: [
        {
          id: 'Academics',
          title: 'Academics'
        },
        {
          id: 'Finance',
          title: 'Finance'
        },
        {
          id: 'Wellness',
          title: 'Wellness'
        },
        {
          id: 'Career',
          title: 'Career'
        }
      ]
    }
  },
  computed: {
    filteredResources () {
      return this.resources.filter((resource) => {
        if (!this.activeFilters.length) return true

        let included = false
        if (this.activeFilters.includes('Popular') && resource.popular) included = true
        if (this.activeFilters.includes('TD Resource') && resource.TDResource) included = true

        // To determine whether a category filter has been applied
        let categoryFilter = false
        this.activeFilters.map(filter => {
          if ((filter === 'Academics') || (filter === 'Finance') || (filter === 'Wellness') || (filter === 'Career')) categoryFilter = true
        })

        if (categoryFilter && this.activeFilters.includes(resource.category)) included = true

        return included
      })
    },
    filtering () {
      return this.activeFilters !== undefined && this.activeFilters.length > 0
    },
    resourceBuckets () {
      let buckets = {}
      for (var i in this.toggleTags) {
        let toggle = this.toggleTags[i]
        let filteredResources = this.resources.filter(resource => {
          return resource[toggle.id] === true
        })
        buckets[toggle.title] = filteredResources
      }

      for (var j in this.categories) {
        let category = this.categories[j]
        let filteredResources = this.resources.filter(resource => {
          return resource.category.toUpperCase() === category.id.toUpperCase()
        })
        buckets[category.title] = filteredResources
      }
      return buckets
    }
  },
  methods: {
    toggleFilter (filterType) {
      const index = this.activeFilters.indexOf(filterType)
      if (index > -1) {
        this.activeFilters.splice(index, 1)
      } else {
        this.activeFilters.push(filterType)
      }
    }
  },
  firestore: {
    resources: db.collection('covid19Resources')
  }
}
</script>
